import { http } from '@/lib/http';
import type { APIResponse } from '@/types';
import { TeamListItem } from '../types';

export type GetBizTeamListParams = {
  oemServiceId: number;
  requestTime: string;
  pagingBizTeamId?: number;
  paging?: string;
  limit?: number;
  bizTeamName?: string;
};

export type GetBizTeamListResponse = APIResponse<Array<TeamListItem>>;

export const getBizTeamList = async (params: GetBizTeamListParams) => {
  return await http<GetBizTeamListResponse>('/user/v1/biz-team', {
    query: {
      oem_service_id: params.oemServiceId,
      request_time: params.requestTime,
      paging_biz_team_id: params.pagingBizTeamId,
      paging: params.paging,
      limit: params.limit,
      biz_team_name: params.bizTeamName,
    },
  });
};
